import { render, staticRenderFns } from "./AutoBlocksTableSettings.vue?vue&type=template&id=b6837fd4&scoped=true&"
import script from "./AutoBlocksTableSettings.vue?vue&type=script&lang=js&"
export * from "./AutoBlocksTableSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6837fd4",
  null
  
)

export default component.exports